<template>
	<div class="save_from">
		<img src="~@/assets/image/csfrom.png" />
		<div class="save_from_row" style="padding-top: 20px">
			<div class="container form_content_r">
				<div class="form_content">
					<div class="title">
						展特易<span>为企业客户提供</span>
					</div>
					<div class="title">
						<span>上百套标准</span>展台参考方案
					</div>
					<div class="des">
						根据需求，选择合适的方案即可在线下单，并且时时查看制作进度。
					</div>
					<div class="form_card">
						<div class="title">展特易展台设计需求评估</div>
						<div class="sub_title">Booth design needs assessment</div>

						<el-form :model="ruleForm" :rules="rules" ref="ruleForm">
							<div class="zq_left">
								<div class="group">

									<div class="input_item">

										<el-form-item label="展会名称" prop="from_meeting_name">
											<el-input v-model="ruleForm.from_meeting_name" placeholder="请输入展会名称">
											</el-input>
										</el-form-item>
									</div>

								</div>
								<div class="group">
									<div class="input_item">

										<el-form-item label="展会地址" prop="from_address">
											<el-input v-model="ruleForm.from_address" placeholder="请输入展会地址"></el-input>
										</el-form-item>
									</div>
									<div class="input_item">

										<el-form-item label="展会日期" prop="from_data">
											<el-date-picker v-model="ruleForm.from_data" type="date" placeholder="选择日期">
											</el-date-picker>
										</el-form-item>
									</div>
								</div>
								<div class="group">
									<div class="input_item">

										<el-form-item label="联系人姓名" prop="from_name">
											<el-input v-model="ruleForm.from_name" placeholder="请输入姓名"></el-input>
										</el-form-item>
									</div>
								</div>
								<div class="group">
									<div class="input_item">

										<el-form-item label="联系人电话" prop="from_tel">
											<el-input v-model="ruleForm.from_tel" placeholder="请输入电话"></el-input>
										</el-form-item>
									</div>
								</div>

								<div class="group">
									<div class="input_item">

										<el-form-item label="设计师" prop="from_deposit">
											<el-radio-group class="checkbtns" v-model="ruleForm.from_deposit">
												<el-radio-button v-for="design in designlist" class="checkbtn"
													v-bind:label="design.id">
													{{design.name}}</br>保证金：{{design.deposit}}
												</el-radio-button>

											</el-radio-group>
										</el-form-item>
									</div>
								</div>

								<div class="group">
									<div class="input_item">
										<el-button class="submitbtn" :loading="btnLoading" @click="submitForm('ruleForm')">确认提交
										</el-button>
									</div>
								</div>
							</div>
							<div class="zq_right">
								<div class="group">
									<div class="input_item">

										<el-form-item label="是否自己搭建" prop="from_build">
											<el-radio-group class="checkbtns" v-model="ruleForm.from_build">
												<el-radio-button class="checkbtn" label="是"></el-radio-button>
												<el-radio-button class="checkbtn" label="否"></el-radio-button>
											</el-radio-group>
										</el-form-item>
									</div>
								</div>
								<div class="group">
									<div class="input_item">

										<el-form-item label="展会预计参展人数" prop="from_people">
											<el-radio-group class="checkbtns" v-model="ruleForm.from_people">
												<el-radio-button class="checkbtn" label="1-10人"></el-radio-button>
												<el-radio-button class="checkbtn" label="10人以上"></el-radio-button>
											</el-radio-group>
										</el-form-item>
									</div>
								</div>
								<div class="group">
									<div class="input_item">

										<el-form-item label="展台尺寸" prop="from_size">
											<el-radio-group @change="showCurSizeDom" class="checkbtns" v-model="curfrom_sizes">
												<el-radio-button  class="checkbtn" label="1">3x3</el-radio-button>
												<el-radio-button  class="checkbtn" label="2">3x6</el-radio-button>
												<el-radio-button  class="checkbtn" label="3">6x6</el-radio-button>
												<el-radio-button  class="checkbtn" label="4">在这填写您想要的尺寸</el-radio-button>
											</el-radio-group>
										</el-form-item>
                                        <el-form-item prop="from_size" v-if="showCurSize">
                                            <el-input  @change="setfrom_size" v-model="curfrom_size"  placeholder="请输入展台尺寸"></el-input>
                                        </el-form-item>
                                    </div>
								</div>
								<div class="group">
									<div class="input_item">

										<el-form-item label="展台预算" prop="from_budget">
											<el-radio-group class="checkbtns" v-model="ruleForm.from_budget">
												<el-radio-button class="checkbtn" label="5k-12k"></el-radio-button>
												<el-radio-button class="checkbtn" label="12k-25k"></el-radio-button>
												<el-radio-button class="checkbtn" label="25k-33k"></el-radio-button>
												<el-radio-button class="checkbtn" label="35k-100k"></el-radio-button>
											</el-radio-group>
										</el-form-item>
									</div>
								</div>

							</div>

						</el-form>


					</div>
				</div>
			</div>
		</div>
	</div>

</template>

<script>
	export default {
		name: "CForm",
		components: {},
		props: {

		},
		data() {
			return {
                curfrom_size:"",
			    showCurSize:false,
				btnLoading:false,
                curfrom_sizes:1,
				designlist: [],
				ruleForm: {
					from_meeting_name: "",
					from_address: "",
					from_data: "",
					from_name: "",
					from_tel: "",
					from_build: "",
					from_people: "",
					from_size: "3x3",
					from_budget: "",
					from_deposit: "",


				},
				rules: {
					from_meeting_name: [{
						required: true,
						message: '请输入展会名称',
						trigger: 'change'
					}],
					from_address: [{
						required: true,
						message: '请输入展会地址',
						trigger: 'change'
					}],
                    curfrom_size:[{
                        required: true,
                        message: '请输入尺寸',
                        trigger: 'change'
                    }],
					from_data: [{
						required: true,
						message: '请输入展会日期',
						trigger: 'change'
					}],
					from_name: [{
						required: true,
						message: '请输入姓名',
						trigger: 'change'
					}],
					from_tel: [{
						required: true,
						message: '请输入联系人电话',
						trigger: 'change'
					}],
					from_build: [{
						required: true,
						message: '请选择搭建模式',
						trigger: 'change'
					}],
					from_people: [{
						required: true,
						message: '请选择展会预计参展人数',
						trigger: 'change'
					}],
					from_size: [{
						required: true,
						message: '请选择尺寸',
						trigger: 'change'
					}],
					from_budget: [{
						required: true,
						message: '请选择预算',
						trigger: 'change'
					}],
					from_deposit: [{
						required: true,
						message: '请选择设计师',
						trigger: 'change'
					}],

				}
			};
		},
		watch: {},
		computed: {

        },
		methods: {
            setfrom_size(){
                this.ruleForm.from_size=this.curfrom_size;
            },
            showCurSizeDom(val){

                if(val==4){
                    this.showCurSize=true;
                }else{
                    this.showCurSize=false;
                }
                switch (val) {
                    case 1:
                        this.ruleForm.from_size="3x3";
                        break;
                    case 2:
                        this.ruleForm.from_size="3x6";
                        break;
                    case 3:
                        this.ruleForm.from_size="6x6";
                        break;
                    case 4:
                        this.ruleForm.from_size="";
                        this.curfrom_size="";
                        break;
                }

            },
			getClassDesign() {
				this.$api.getClassDesign().then(res => {
					if (res.status) {
						this.designlist = res.data;
						console.log("designlist", this.designlist);
					}
				})
			},
			toPay(){
				let data={
					params:this.ruleForm
				}
				this.$api
						.create2Order(data)
						.then(res => {
							if (res.status) {
								this.btnLoading = false
								this.$router.replace({
									name: 'cashier',
									params: {
										order_id: res.data.order_id,
									},
								})
							} else {
								this.$msg(res.msg, 'error')
								this.btnLoading = false
							}
						})
						.catch(err => {
							this.btnLoading = false
						})

			},
			submitForm(formName) {
				this.btnLoading = true
				this.$refs[formName].validate((valid) => {
					if (valid) {
						this.toPay();
					} else {
						this.btnLoading = false;
						console.log('error submit!!');
						return false;
					}
				});
			},
			buyNow() {
				let data = {
					//product_id: this.product.id,
					//nums: this.buyNum,
					type: 2, // 区分加入购物车和购买
				}
				this.$api.addCart(data).then(res => {
					if (res.status) {
			 		console.log("buyNow");
						let cartIds = res.data
						this.$router.push({
							name: 'order',
							query: {
								cart_ids: JSON.stringify(cartIds)
							},
						})
			 	} else {
						this.$message({
							message: res.msg,
							type: 'error',
						})
					}
				})
			},
		},
		created() {
			this.getClassDesign();
		},
		mounted() {}
	};
</script>

<style lang="scss" scoped>
	::v-deep .el-button--primary {

		background-color: #64B281;
		border-color: #64B281;
	}

	::v-deep .el-radio-button__orig-radio:checked+.el-radio-button__inner {
		background-color: #64B281;
		border-color: #64B281;
		-webkit-box-shadow: -1px 0 0 0 #64B281;
		box-shadow: -1px 0 0 0 #64B281;
	}

	.save_from {
		background: url(~@/assets/image/csfrom.png) no-repeat;
		background-size: cover;
		position: relative;
		width: 100%;
		overflow: hidden;

		.save_from_row {
			position: absolute;
			width: 100%;
			height: 100%;
			top: 0;
			left: 0;
			display: flex;
			justify-content: center;

			.form_content {
				width: 67%;

				.title {
					font-family: SourceHanSansCN-Regular;
					font-size: 50px;
					color: #000000;
					letter-spacing: -1.7px;
					font-weight: 400;

					span {
						font-weight: 700;
					}
				}

				.des {
					font-family: PingFangSC-Regular;
					font-size: 18px;
					color: #5E5E5E;
					letter-spacing: 0;
					line-height: 28px;
					font-weight: 400;
					padding-top: 30px;
					padding-bottom: 50px;
				}

				.form_card {
					background: #FFFFFF;
					box-shadow: 0px 3px 50px 0px rgba(59, 115, 79, 0.16);
					padding: 45px 35px;

					.title {
						font-family: PingFangSC-Semibold;
						font-size: 24px;
						color: #2B2D2C;
						letter-spacing: -0.5px;
						font-weight: 600;
					}

					.sub_title {
						font-family: Roboto-Regular;
						font-size: 16px;
						color: #5E5E5E;
						letter-spacing: 0.32px;
						font-weight: 400;
						margin-bottom: 26px;
						margin-top: 4px;
					}

					form {
						display: flex;

						.zq_left {
							width: 50%;
						}

						.zq_right {
							width: 50%;

							::v-deep .el-radio-button__inner {
								border: 0px !important;
								width: 100%;
								padding: 12px 10px;
							}

							.checkbtn {
								opacity: 0.7;
								font-family: PingFangSC-Regular;
								font-size: 12px;
								color: #000000;
								letter-spacing: 0.4px;
								text-align: center;
								font-weight: 400;
								display: flex;
								border: 1px solid rgba(0, 0, 0, 1) !important;
								border-radius: 2px;
								justify-content: center;
								align-items: center;
								margin-right: 10px;
								overflow: hidden;
							}
						}

						.submitbtn {
							background: #64B281;
							border-radius: 2px;
							font-family: PingFangSC-Semibold;
							font-size: 16px;
							color: #FFFFFF;
							letter-spacing: 1.6px;
							text-align: center;
							font-weight: 600;
							display: inline-block;
							padding: 13px 64px;
							width: 200px;
						}
					}

					.group {
						padding: 20px 0;
						display: flex;

						.input_item {
							display: flex;
							flex-direction: column;
							width: 100%;
							padding-right: 22px;
						}

						.checkbtns {
							width: 100%;
							display: flex;

							label {
								margin-bottom: 0px;

							}
						}

						label {
							font-family: SourceHanSansCN-Bold;
							font-size: 12px;
							color: #090A0D;
							font-weight: 700;
							margin-bottom: 12px;
						}

						input {
							background: #FFFFFF;
							border: 1px solid rgba(229, 229, 229, 1);
							border-radius: 3px;
							height: 40px;

						}
					}
				}
			}
		}
	}

	::v-deep .el-form-item__label {
		font-family: SourceHanSansCN-Bold;
		font-size: 12px;
		color: #090A0D;
		font-weight: 700;

	}
</style>
